/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_EditInputs */

const cs_requirements_edit = /** @type {(inputs: Requirements_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit poptávku`)
};

const en_requirements_edit = /** @type {(inputs: Requirements_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit demand`)
};

/**
* | output |
* | --- |
* | "Edit demand" |
*
* @param {Requirements_EditInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_edit = /** @type {((inputs?: Requirements_EditInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_EditInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_edit(inputs)
	return cs_requirements_edit(inputs)
});